export default{
  clients: state => {
    return state.clients
  },
  total: state => {
    return state.total
  }
}